import axios from "axios";

import { MainUrl } from "../constants";

const API_URL = `${MainUrl}/ofd`;

export const GetOFDByDates = async (token, startDate, endDate) => {
  try {
    const response = await axios.get(
      `${API_URL}/?start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const GetOFDByDatesForSchedule = async (token, startDate, endDate) => {
  try {
    const response = await axios.get(
      `${API_URL}/schedule/?start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};
